import axios from "axios";
import { getCookie } from "../../utils";
import { API_BASE_PATH } from "../../const";

const getApiKeys = (args) => {
    
    return axios
        .get(API_BASE_PATH + `api_keys/`, {
            headers: {
                'X-CSRFToken': getCookie("csrftoken"),
            }
        })
        .then((response) => {
            return response.data;
        });
};

const getApiKeyDetail = (args) => {
    
    return axios
        .get(API_BASE_PATH + `api_keys/${args.customerId}/`, {
            headers: {
                'X-CSRFToken': getCookie("csrftoken"),
            }
        })
        .then((response) => {
            return response.data;
        });
};

const createApiKey = (args) => {
    
    return axios
        .post(API_BASE_PATH + `api_keys/create_key_set/`, {
                ...args
            }, {
                headers: {
                    'X-CSRFToken': getCookie("csrftoken"),
                }
            })
            .then((response) => {
                return response.data;
            });
};

const deleteApiKey = (id) => {

    return axios
        .delete(API_BASE_PATH + `api_keys/${id}/`, {
            headers: {
                'X-CSRFToken': getCookie("csrftoken"),
            }
        })
        .then((response) => {
            return response.data;
        });
}

const ApiKeysService = {
    getApiKeys,
    getApiKeyDetail,
    createApiKey,
    deleteApiKey
};

export default ApiKeysService;